/* blocks */
import IndividualCaseStudyPageHero from './components/CaseStudyHero/IndividualCaseStudyPageHero'
import CaseStudyMetaDetails from './components/CaseStudyMetaDetails/CaseStudyMetaDetails'
import CaseStudyContent from './components/CaseStudyContent/CaseStudyContent'
import MoreCaseStudies from './components/MoreCaseStudies/MoreCaseStudies'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import { IndividualCaseStudyPageAttributes } from '@/utils/queries/individual-case-studies-page'

/* styles */
import styles from './_.module.css'

interface Props {
  data: IndividualCaseStudyPageAttributes
}

function CaseStudyIndividualPages({ data }: Props) {
  return (
    <>
      <IndividualCaseStudyPageHero
        title={data.heroTitle}
        description={data.heroDescription}
        heroBgColor={data.heroBgColor}
        heroTextColor={data.heroTextColor}
        featuredImage={data.featuredImage.data.attributes}
        customerLogo={data.customerLogo.data.attributes}
        stats={data.statisticsList.map(item => ({
          title: item.title ?? '',
          description: item.description ?? ''
        }))}
      />

      {data.caseStudyMetadata.length > 0 ? (
        <CaseStudyMetaDetails
          bgColor={data.caseStudyMetadataBgColor}
          textColor={data.caseStudyMetadataTextColor}
          metadata={data.caseStudyMetadata.map(item => ({
            title: item.title ?? '',
            description: item.description ?? ''
          }))}
        />
      ) : null}

      {data.content ? (
        <CaseStudyContent
          class={styles.content}
          content={data.content}
          testimonial={data.testimonial}
          videoUrl={data.testimonialVideoUrl}
        />
      ) : null}

      {data.moreCaseStudies.data.length > 0 ? (
        <MoreCaseStudies
          title="More Customer Stories"
          data={data.moreCaseStudies.data}
          showViewMore={false}
        />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
          mode="full_width"
          variant="blue"
        />
      ) : null}
    </>
  )
}

export default CaseStudyIndividualPages
